<template>
<div class="menuBody" >
    <BillManTree @AllData="getMsgFormSon" @NodeData="NodeData" />
        <BillTypeDialog :param="diaLogData" ref="BillTypeDialog" @Visible="Visible" />
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                 票据类型列表   <!--  管理类型设置  -->
            </div>
             <div style="width:200px;float:left;">
                 <el-input placeholder="请输入票据类型" size="small"     v-model="groupName"></el-input>
            </div>
             <div style="float:left;margin-left:30px">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bs:bmTs:selectListPage'" @click="Inquire()">查询</el-button>
            </div>
            <div style="float:right;margin-top:-5px;margin-right:10px">
                <el-button type="primary" v-show="this.mangroupId !='' " size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bs:bmTs:save'"  @click="PropertyAdd()">票据类型添加</el-button>
            </div>
          <el-table  :data="tableData" tooltip-effect="light"  v-loading="loading"   style="overflow-y: scroll;float:right;margin-top:30px" 
    row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="typeNum" label="票据类型代号" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="typeName" label="票据类型" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="createDate" label="创建时间" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="updateDate" label="更新时间" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="remarks" label="备注"></el-table-column>
    <el-table-column fixed="right" label="操作">
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" v-Jurisdiction="'expense:web:bs:bmTs:save'"  circle size="small" title="修改"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" v-Jurisdiction="'expense:web:bs:bmTs:delete'" circle size="small" title="删除"  v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import BillTypeDialog from "../common/BillTypeDialog";
import BillManTree from "../common/BillManTree.vue";

export default {
  name: "BillType",
  components: {BillTypeDialog,BillManTree},
  data() {
    return {
 
      total:0,
      loading:false,
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        groupNum:"",
        groupName:"",
        UpCourseCode:"",
        amount:[],
        amountval:"",
      tableData: [],
      options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERObj:"",
      ProjectMana:"",
      taxRateval:"",
      taxRatelab:"",
      mangroupId:"",
      BillListo:"",
    }
  },
  methods: {
    expend(){
    },
    handleSelectionChange(val){
      this.USERObj = val
    },
    getMsgFormSon(data){
      this.AllData = data
    },
    NodeData(data){
      this.loading = true
        this.mangroupId = data.value
        this.mangrouplab = data.label
   this.ShareList()
    },
    ShareList(){
 let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "mangroupId":this.mangroupId,
      }
        this.$http.post(this.$requestUrl.POST_BILLTYPE_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    handleSizeChange(val) {
      this.pagesize = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
    Inquire(){
      this.loading = true
    let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "typeName":this.groupName,
        "mangroupId":this.mangroupId,
      }
        this.$http.post(this.$requestUrl.POST_BILLTYPE_LIST,PageSize).then((res) => {
          let data = res.data;
 
          if (200 === data.code) {
            this.tableData = data.data.records;
            this.groupName = ""
            this.loading = false
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      
    },
    PropertyAdd(){
        // 添加项目
        if(this.USERObj.length == 0){
            this.$refs.BillTypeDialog.title = "添加";
            this.$refs.BillTypeDialog.dialogVisible = true; 
            this.$refs.BillTypeDialog.options = this.AllData;
            this.$refs.BillTypeDialog.BillList = this.BillListo
            this.$refs.BillTypeDialog.value = "";
            this.$refs.BillTypeDialog.billvalue = "";
          let obj = {
            "mangroupName":"票据管理组",
            "BillListName":"票据类型",
            "remarks":"备注信息",
          }
          let row = {}
          row.obj = obj
         this.$refs.BillTypeDialog.formLabelAlign= row;
        }
    },
    editMenu(row) { // 修改
      this.$refs.BillTypeDialog.title = "修改";
      this.$refs.BillTypeDialog.dialogVisible = true;
      this.$refs.BillTypeDialog.options = this.AllData;
      this.$refs.BillTypeDialog.BillList = this.BillListo
      this.$refs.BillTypeDialog.value = this.mangrouplab;
      this.$refs.BillTypeDialog.Pid = this.mangroupId;
      this.$refs.BillTypeDialog.billvalue = row.typeNum
      this.$refs.BillTypeDialog.typeName = row.typeName
        let obj = {
            "mangroupName":"票据管理组",
            "BillListName":"票据类型",
            "remarks":"备注信息",
          }
        row.obj = obj
         this.$refs.BillTypeDialog.formLabelAlign= row;
        },
    delMenu(row){
          this.$confirm('是否确认要删除该类型?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
     this.$http.post(this.$requestUrl.DELETE_BILLTYPE+"?id="+row.id).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.ShareList()
             this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else{
           this.$message({
            type: 'warning',
            message: '删除失败'
          });
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    BillList(){
      this.$http.get(this.$requestUrl.POST_BILLLIST_TYPE).then((res)=>{
        let arr = []
        for(let val of res.data.data){
            let bill = {
              "billvalue":val.typeNum,
              "billlabel":val.name,
              "billtype":val.id,
            }
            arr.push(bill)
        }
        this.BillListo = arr

      })
    },
           Visible(data){
      if(data == false){
        this.loading = true
       this.ShareList()
      }
    }

  },
  mounted() {
    this.BillList()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>